import React from "react";
import FavouriteButton from "Atoms/FavouriteButton";
import { COUNTRIES } from "Utils/globals";
const LocationHeader = ({ gid, city, country, kommune = "" }) => {
  const item = {
    city,
    country,
    kommune,
    id: gid,
  };
  return (
    <>
      <span className="header-block-weather-now">LIGE NU</span>
      <h1 className="header-block-weather-title">
        {city}
        <FavouriteButton item={item} size={"medium"} />
      </h1>
      {country !== "DK" && gid >= 100 && (
        <div className="countryname">{COUNTRIES[country]}</div>
      )}
      {gid < 100 && <div className="countryname">Farvand</div>}
    </>
  );
};

export default LocationHeader;
